module.exports = __webpack_public_path__ + "media/hallBgm.d6a98d43.mp3";